import api from './api'

export const socialMediaService = {
  // Get Instagram posts
  async getInstagramPosts(limit = 10) {
    const response = await api.get('/social/instagram', { params: { limit } })
    return response.data
  },

  // Get Facebook posts
  async getFacebookPosts(limit = 10) {
    const response = await api.get('/social/facebook', { params: { limit } })
    return response.data
  },

  // Get all social media posts
  async getAllSocialPosts(limit = 20) {
    const response = await api.get('/social/all', { params: { limit } })
    return response.data
  }
}
